import { render, staticRenderFns } from "./CardHegu.vue?vue&type=template&id=7c238aba&scoped=true&"
import script from "./CardHegu.vue?vue&type=script&lang=js&"
export * from "./CardHegu.vue?vue&type=script&lang=js&"
import style0 from "./CardHegu.vue?vue&type=style&index=0&id=7c238aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c238aba",
  null
  
)

export default component.exports